export const resolveAdminServiceLink = (link, language, localizePath) => {
  if (!link || typeof link.url !== 'string' || !link.url) return '#';
  if (link.route_type === 'react') return localizePath(link.url, language);
  return link.url;
};
